import { isValidNationalId } from "@leabankab/component-library";
import {
	type NationalIdCountry,
	normalizeNationalId,
} from "@/utils/validation/normalize-national-id";

/** True when both IDs are valid and normalize to the same value. */
export const areDuplicateNationalIds = (
	country: NationalIdCountry,
	mainNationalId: string | undefined,
	coNationalId: string | undefined
): boolean => {
	if (!mainNationalId?.trim() || !coNationalId?.trim()) {
		return false;
	}

	const main = normalizeNationalId(country, mainNationalId);
	const co = normalizeNationalId(country, coNationalId);

	return (
		isValidNationalId(country, main) &&
		isValidNationalId(country, co) &&
		main === co
	);
};
